import React, { useState } from 'react';
import { FiBell, FiX, FiCheck, FiAlertCircle, FiInfo, FiAlertTriangle, FiTrash2 } from 'react-icons/fi';
import { useOperations } from '../../contexts/OperationsContext';

const NotificationCenter: React.FC = () => {
  const { notifications, unreadCount, markAllRead, clearNotifications } = useOperations();
  const [isOpen, setIsOpen] = useState(false);

  const iconForType = (type: string) => {
    switch (type) {
      case 'success': return <FiCheck className="notif-icon notif-icon-success" />;
      case 'error': return <FiAlertCircle className="notif-icon notif-icon-error" />;
      case 'warning': return <FiAlertTriangle className="notif-icon notif-icon-warning" />;
      default: return <FiInfo className="notif-icon notif-icon-info" />;
    }
  };

  const timeAgo = (date: Date) => {
    const diff = Date.now() - date.getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'teraz';
    if (mins < 60) return `${mins} min temu`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h temu`;
    return `${Math.floor(hrs / 24)}d temu`;
  };

  return (
    <div className="notif-center">
      <button
        className="notif-trigger"
        onClick={() => { setIsOpen(!isOpen); if (!isOpen) markAllRead(); }}
        title="Powiadomienia"
      >
        <FiBell size={16} />
        {unreadCount > 0 && (
          <span className="notif-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
        )}
      </button>

      {isOpen && (
        <>
          <div className="notif-backdrop" onClick={() => setIsOpen(false)} />
          <div className="notif-dropdown">
            <div className="notif-dropdown-header">
              <h4>Powiadomienia</h4>
              <div style={{ display: 'flex', gap: '4px' }}>
                {notifications.length > 0 && (
                  <button className="btn btn-link btn-sm" onClick={clearNotifications} title="Wyczyść">
                    <FiTrash2 size={12} />
                  </button>
                )}
                <button className="btn btn-icon btn-sm" onClick={() => setIsOpen(false)}>
                  <FiX size={14} />
                </button>
              </div>
            </div>
            <div className="notif-dropdown-body">
              {notifications.length === 0 ? (
                <div className="notif-empty">
                  <FiBell size={24} style={{ opacity: 0.2, marginBottom: '8px' }} />
                  <span>Brak powiadomień</span>
                </div>
              ) : (
                notifications.map((n) => (
                  <div key={n.id} className={`notif-item ${!n.read ? 'notif-unread' : ''}`}>
                    <div className="notif-item-icon">{iconForType(n.type)}</div>
                    <div className="notif-item-content">
                      <div className="notif-item-title">{n.title}</div>
                      <div className="notif-item-message">{n.message}</div>
                      <div className="notif-item-time">{timeAgo(n.timestamp)}</div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationCenter;
